<template>
  <div>
    <ValidationProvider :name="$t(itemName)" rules="required" v-slot="{ errors }">
      <v-autocomplete
        v-model="editedBom"
        :items="bomList"
        item-text="Name"
        item-value="Id"
        return-object
        :loading-text="$t('common_get_data')"
        :no-data-text="$t('common_no_results')"
        :error-messages="errors[0]"
        @click="getAllBoms"
        @change="setBomItem"
        ref="bomNameAutocomplete"
        @keyup.enter="keyupEnter"
      >
        <template v-slot:item="data">
          <template>
            <v-list-item-content>
              <v-list-item-title>
                {{ data.item.Name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ data.item.Describe }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon v-if="!data.item.disabled">
              <v-icon color="green" class="mr-2"> mdi-check </v-icon>
            </v-list-item-icon>
            <v-list-item-icon v-if="data.item.disabled">
              <v-icon color="grey" class="mr-2"> mdi-close </v-icon>
            </v-list-item-icon>
          </template>
        </template>
        <template slot="append">
          <v-tooltip top color="red lighten-5">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="grey" dark v-bind="attrs" v-on="on">
                mdi-information
              </v-icon>
            </template>
            <span>
              <v-icon color="green" class="mr-2"> mdi-check </v-icon>
              <span style="color: green">
                {{ $t('quotation_item_new_exist') }}
              </span>
            </span>
            <br />
            <span>
              <v-icon color="grey" class="mr-2"> mdi-close </v-icon>
              <span style="color: grey">
                {{ $t('quotation_item_new_no_exist') }}
              </span>
            </span>
          </v-tooltip>
        </template>
        <template v-slot:label>
          <span class="red--text">
            <strong>* </strong>
          </span>
          {{ $t('quotation_item_name') }}
        </template>
      </v-autocomplete>
    </ValidationProvider>
  </div>
</template>

<script>
import { HttpBom } from '@/js/http-Manager'
import axios from 'axios'
export default {
  name: 'QuotationBomAndVBomForRepairPriceAutocomplete',
  props: {
    fatherEditedItem: {
      type: Object
    },
    editedItemIndex: {
      type: Number
    },
    itemName: {
      type: String
    },
    repairCustomerId: {
      type: String
    },
    refName: {
      type: String
    },
    customerDeviceType: {
      type: Number
    }
  },
  components: {},
  data: () => ({
    bomList: [],
    bomSource: null,
    isLoading: false,
    editedBom: {
      Number: '',
      Name: '',
      Price: 0,
      Unit: '',
      Quantity: 0,
      Describe: '',
      BomItems: [],
      Remark: ''
    },
    defaultBom: {
      Number: '',
      Name: '',
      Price: 0,
      Unit: '',
      Quantity: 0,
      Describe: '',
      BomItems: [],
      Remark: ''
    }
  }),
  async mounted () {
    await this.getAllBoms()
  },
  watch: {
    async fatherEditedItem (val) {
      if (val.Id === '') {
        await this.getAllBoms()
        this.editedBom = JSON.parse(JSON.stringify(this.defaultBom))
      } else {
        this.editedBom = JSON.parse(JSON.stringify(val))
      }
    },
    async customerDeviceType (oldVal, newVal) {
      if (
        ((oldVal === 0 || oldVal === 3) && (newVal === 1 || newVal === 2)) ||
        ((oldVal === 1 || oldVal === 2) && (newVal === 0 || newVal === 3))
      ) {
        await this.getAllBoms()
        this.$emit('setBomItem', this.defaultBom)
      }
    }
  },
  methods: {
    async getAllBoms () {
      this.isLoading = true
      if (this.bomSource) {
        this.bomSource.cancel('cancel')
      }
      let cancelToken = axios.CancelToken
      this.bomSource = cancelToken.source()
      let param = {
        customerId: this.repairCustomerId,
        customerDeviceType: this.customerDeviceType ? this.customerDeviceType : null
      }
      let response = await HttpBom.GetRepairPriceBomAndVBomListFromCustomerDevice(
        param,
        this.bomSource.token
      )
      this.isLoading = false
      if (response) {
        this.bomList = response.status === 200 ? response.data.Data : []
        this.bomSource = null
      }
    },
    setBomItem () {
      this.$emit('setBomItem', this.editedBom)
    },
    keyupEnter (event) {
      this.$refs[this.refName].isMenuActive = false
      this.$refs[this.refName].isFocused = false
      this.$emit('keyupEnter', event)
    }
  }
}
</script>
